import React from "react";
import { Chip } from "@mui/material";

const StatusChip = ({ variant = "approved", label }) => {
  const config = {
    approved: {
      bgColor: "#D0F5D0",
      color: "#429A42",
    },
    review: {
      bgColor: "#FFF8F1",
      color: "#DC6600",
    },
    submit: {
      bgColor: "#E9F2FF",
      color: "#1D7AFC",
    },
    notApproved: {
      bgColor: "#FFECF2",
      color: "#B6174B",
    },
    pending: {
      bgColor: "#fff7d6",
      color: "#b38600",
    },
  };

  const badgeConfig = config[variant] || config.approved;

  return (
    <Chip
      icon={
        <span
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: badgeConfig.color,
          }}
        />
      }
      label={label}
      sx={{
        backgroundColor: badgeConfig.bgColor,
        color: badgeConfig.color,
        fontWeight: 600,
        padding: "4px 12px",
        fontSize: "12px",
        borderRadius: "4px",
        height: "32px",
        display: "inline-flex",
        alignItems: "center",
      }}
    />
  );
};

export default StatusChip;
